import { render, staticRenderFns } from "./KorpaView.vue?vue&type=template&id=01abc630&"
import script from "./KorpaView.vue?vue&type=script&lang=js&"
export * from "./KorpaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports